import { clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * tailwind-merge has to be told about any scale we invent, or it guesses.
 *
 * It classifies an unknown `text-*` as a text COLOUR and an unknown
 * `border-*-*` as a border COLOUR. Left unconfigured, that silently deletes
 * classes: `cn('text-primary-hover', 'text-meta')` dropped the colour because
 * both looked like colours, and `cn('border-r-hairline border-border-chrome')`
 * dropped the width because the all-sides colour appeared to supersede it.
 *
 * Registering the custom scales here fixes the whole class of bug at once.
 * **Anything added to `fontSize` or `borderWidth` in tailwind-preset.js must be
 * added here too.**
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      // fontSize keys from the preset
      'font-size': [{ text: ['label', 'meta', 'title'] }],
      // borderWidth keys from the preset, per side
      'border-w': [{ border: ['hairline'] }],
      'border-w-x': [{ 'border-x': ['hairline'] }],
      'border-w-y': [{ 'border-y': ['hairline'] }],
      'border-w-t': [{ 'border-t': ['hairline'] }],
      'border-w-r': [{ 'border-r': ['hairline'] }],
      'border-w-b': [{ 'border-b': ['hairline'] }],
      'border-w-l': [{ 'border-l': ['hairline'] }],
    },
  },
});

/**
 * Conditional classnames with Tailwind conflict resolution.
 *
 *   cn('px-2 py-1', isWide && 'px-4')  ->  'py-1 px-4'
 *
 * Always use this instead of template strings so a caller's className can
 * override a component's default without specificity games.
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export default cn;
